package pl.decks.personal.components.widgets.mail

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import pl.decks.personal.components.layouts.site.SiteNavigationJourney
import pl.decks.personal.components.widgets.LeadingIconRow
import pl.decks.posthog.client.PostHogClient

const val CURRENT_ROTATIONAL_MAIL = "piablaze.press151@passmail.net"

@Composable
fun MailLink(address: String = CURRENT_ROTATIONAL_MAIL, modifier: Modifier = Modifier)
= Link(
    "mailto:$address",
    modifier = Modifier
        .onClick { PostHogClient.capture(SiteNavigationJourney.MailContactInitiated(address)) }
        .then(modifier),
    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
    openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
) {
    LeadingIconRow(icon = { FaEnvelope() }) { SpanText(address) }
}
